<div *ngIf="calculation">

  <div class="fs-2 mb-2 text-primary">
    Parametry kalkulace
  </div>

  <div class="border p-3 mb-4">

      <div class="fw-bold mb-4">
        Identifikátor kalkulace: {{calculation.id}}
      </div>
      <div class="">
        Rozměry: {{calculation.height}} cm x {{calculation.width}} cm
      </div>
      <div class="">
        Počet kusů: {{calculation.count}} ks
      </div>
      <div class="">
        Doplňkové služby:
        <ul>
          <li *ngFor="let service of calculation.serviceLists">{{service.name}}</li>
        </ul>
      </div>

  </div>

  <div class="fs-2 mb-2 text-primary">
    Výsledná kalkulace
  </div>

  <div class="border p-3 mb-4">

      <div class="fs-4 fw-bold text-primary">
        Vypočtená cena: {{calculation.calculatedPrice}} Kč
      </div>
      <div class="small">
        Platnost kalkulace: {{calculation.validUntil}}
      </div>

  </div>

</div>

<div class="d-grid">
  <button class="btn btn-lg w-full rounded-pill btn-primary btn-block" (click)="customerStep()">Mám zájem</button>
</div>
